import { useState } from 'react';

import { IDisturbanceBannerViewModel } from 'Types/Litium';
import Markup from 'Components/Markup';

import CloseIcon from 'Icons/close.svg?react';

const DisturbanceBanner = ({
    text,
    backgroundColor,
    closeBannerText,
    textWidthMobile,
}: IDisturbanceBannerViewModel) => {
    const [showDistrurbanceBanner, setShowDisturbanceBanner] = useState(true);

    const closeDisturbanceBanner = () => {
        document.cookie =
            'disturbance-banner-dismiss=true; path=/; max-age=86400';
        setShowDisturbanceBanner(false);
    };

    return (
        <div
            className={`grid origin-top transition-[grid-template-rows,_opacity,_visibility] duration-layout ${
                showDistrurbanceBanner
                    ? 'opacity-1 visible grid-rows-[1fr]'
                    : 'invisible grid-rows-[0fr] opacity-0'
            } `}
        >
            <div className="overflow-hidden">
                <div
                    style={
                        {
                            '--bg-color': backgroundColor,
                            '--textWidth': `${textWidthMobile}%`,
                        } as React.CSSProperties
                    }
                    className="flex flex-nowrap justify-center gap-2 bg-[var(--bg-color)] px-4 py-2"
                >
                    <Markup
                        html={text?.value}
                        cssClass={`not-prose mb-0 !leading-4 ${
                            textWidthMobile
                                ? 'w-[var(--textWidth)] mx-auto'
                                : ''
                        } md:w-full`}
                    />
                    <button
                        className={`${textWidthMobile ? 'flex' : ''}`}
                        title={closeBannerText}
                        type="button"
                        onClick={() => closeDisturbanceBanner()}
                    >
                        <span className="sr-only">{closeBannerText}</span>
                        <CloseIcon className="h-5 w-5 text-black" />
                    </button>
                </div>
            </div>
        </div>
    );
};

export default DisturbanceBanner;
